import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackClarityPage } from '@/lib/clarity';

export const ClarityPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackClarityPage(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
};
